import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import Banner from "../components/Banner";
import ContentContainer from "../components/ContentContainer";
import Title from "../components/Title";
import AboutUsImage from '../assets/imgs/about_us.jpg';
import BenefitImage from '../assets/imgs/benefit.png';
import {Col, Row, Space, Typography} from "antd";
import {GREE_1, GREE_2, GREE_3} from "../utils/colors";
import BenefitItem from "../components/BenefitItem";
import CardNews from "../components/CardNews";
import Section from "../components/Section";
import ENDPOINTS from "../constants/endpoints";
import ImageBackground from "../components/ImageBackground";
import BannerWhite from "../assets/imgs/bg_2.jpg";
import ImageBeneficio from "../assets/imgs/beneficio.jpg";
import ImageProdutos from "../assets/imgs/Produtos.png";
import ImageBenefit1 from "../assets/imgs/benefit_1.png";
import ImageBenefit2 from "../assets/imgs/benefit_2.png";
import ImageBenefit3 from "../assets/imgs/benefit_3.png";
import ImageBenefit4 from "../assets/imgs/benefit_4.png";
import ImageBenefit5 from "../assets/imgs/benefit_5.png";
import ImageBenefit6 from "../assets/imgs/benefit_6.png";
import ImageBenefit7 from "../assets/imgs/benefit_7.png";
import Text from "../components/Text";
import MainTitle from "../components/MainTitle";
import {getRecentHomeNewsMock} from "../mocks/newsMock";
import ScrollAnimation from "../components/animations/ScrollAnimation";
import api from "../services/api";
import { useSiteSettings } from "../contexts/SiteSettingsContext";

const {Paragraph} = Typography


const Benefit = styled(Section)`

    background: ${GREE_2};

`

const ImgProduto = styled.img`
    width: 100%;
    max-width: 700px;
`


const VideoYoutube = styled.iframe`
    width: 100%;
    height: 300px;

`

const MapContainer = styled.div`
    width: 100%;
    height: 450px;

    @media (max-width: 768px) {
        height: 300px;
    }
`

const GoogleMap = styled.iframe`
    width: 100%;
    height: 100%;
    border: 0;
`
const ImageContainerAboutUs = styled.div`
    position: sticky;
    top: 30px;
`

const ImageWithGradient = styled.div`
    width: 100%;
    height: 594px;
    position: sticky;
    top: 30px;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 100%;
        background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
        z-index: 1;
        pointer-events: none;
        display: none;

        @media (min-width: 992px) {
            display: block;
        }
    }
`

const Image = styled.img`
    width: 100%;
    height: 594px;
    position: sticky;
    top: 30px;
    object-fit: cover;
`


const ImageContainer = styled.div`
    width: 100%;
    height: 594px;
    position: relative;


    ::before {
        content: "";
        width: 100%;
        height: 100%;
        display: block;
        top: 0;
        left: 0;
        position: absolute;
        z-index: 1;
        transform: translateX(0px);
        backdrop-filter: drop-shadow(2px 2px 5px rgb(0 0 0 / 0.5));
        background: rgb(216, 216, 216);
        background: linear-gradient(90deg, rgba(216, 216, 216, 1) 5%, rgba(245, 245, 245, 0) 100%);
    }

`


export default function Home() {
    const { settings } = useSiteSettings();
    const [recentNews, setRecentNews] = useState([])

    useEffect(() => {
        // setRecentNews(getRecentHomeNewsMock());

        async function fetchRecentNews() {
            const {data} = await api.get(ENDPOINTS.RECENT_NEWS_HOME)

            setRecentNews(data)
        }

        fetchRecentNews()
    }, [])


    return (
        <>
            <Banner/>
            <Section>
                {/*<ImageBackground*/}
                {/*    src={BannerWhite}/>*/}
                <ContentContainer>


                    <Row gutter={[16, 16]}>

                        <Col md={18} lg={12}>

                            <Row style={{
                                // background: 'white',
                                // marginTop: 64,
                                // marginLeft: -32,
                                // padding: '16px 50px'
                            }}>
                                <Col>
                                    <ScrollAnimation threshold={1}>
                                        <MainTitle>Quem somos?</MainTitle>
                                    </ScrollAnimation>

                                </Col>
                                <Col>
                                    <ScrollAnimation delay={0.2}>
                                        <Text>
                                            Centro Brasileiro de Pesquisa da
                                            Cannabis Medicinal, uma associação
                                            sem
                                            fins lucrativos, autorizada
                                            judicialmente pela Justiça Federal
                                            da
                                            Paraíba a cultivar e produzir
                                            cannabis
                                            para fins medicinais e
                                            terapêuticos.
                                        </Text>
                                        <Text>
                                            Nosso trabalho nasce do compromisso
                                            com
                                            a vida, a saúde e a justiça social.
                                            Atuamos na redução das
                                            desigualdades,
                                            no fortalecimento da agricultura
                                            familiar e na defesa de políticas
                                            públicas que coloquem as
                                            necessidades
                                            das famílias em primeiro lugar.
                                        </Text>
                                        <Text>
                                            Promover a educação, disseminação
                                            de
                                            conhecimentos populares e
                                            sistematizados acerca do uso
                                            medicinal
                                            da Cannabis. E assim, a consequente
                                            conscientização da sociedade quanto
                                            ao
                                            acesso, benefícios e possibilidades
                                            terapêuticas decorrentes da
                                            utilização
                                            do potencial medicinal da Cannabis.
                                            E
                                            além disso, atuar por conta própria
                                            ou
                                            em parcerias com entidades da
                                            sociedade
                                            civil organizada nacionalmente e
                                            internacionalmente, e junto ao
                                            Poder
                                            Público.
                                        </Text>
                                        <Text>
                                            Contamos com uma ampla rede de
                                            profissionais de saúde – médicas,
                                            médicos, psicólogas, psicólogos,
                                            acolhedoras e assistentes sociais –
                                            atuando em todo o Brasil,
                                            oferecendo
                                            cuidado e acompanhamento humanizado
                                            aos
                                            nossos associados
                                        </Text>
                                        <Text>
                                            Produzimos óleos ricos em CBD e THC
                                            +
                                            CBD, além de pomadas à base de
                                            extrato
                                            de Cannabis. Também estamos em fase
                                            de
                                            pesquisa e desenvolvimento de
                                            cosméticos e outros produtos feitos
                                            com
                                            Cannabis e plantas nativas do
                                            semiárido
                                            nordestino, unindo saberes
                                            tradicionais
                                            à ciência para cuidar com respeito
                                            e
                                            responsabilidade.
                                        </Text>
                                        <Text>
                                            Na CEBRAPCAM, acreditamos que
                                            cuidar da saúde é um direito — e
                                            que cultivar a terra com amor
                                            também é cultivar dignidade.
                                        </Text>
                                    </ScrollAnimation>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6} lg={12}>
                            <ImageContainerAboutUs>


                                <ScrollAnimation delay={0.2}
                                                 direction={'left'}>
                                    <ImageWithGradient>
                                        <Image src={AboutUsImage}/>
                                    </ImageWithGradient>
                                </ScrollAnimation>
                            </ImageContainerAboutUs>
                        </Col>
                    </Row>

                </ContentContainer>
            </Section>

            <Benefit>
                <ImageBackground
                    src={ImageBeneficio}/>
                <ContentContainer>
                    <Row gutter={[16, 32]}>
                        <Col xs={12}>
                            <ScrollAnimation threshold={1}>
                                <MainTitle>Benefícios
                                    dos nossos produtos</MainTitle>
                            </ScrollAnimation>

                        </Col>
                        <Col xs={24} style={{}}>
                            <ScrollAnimation threshold={1}>
                                <ImgProduto src={ImageProdutos}/>
                            </ScrollAnimation>
                        </Col>
                        <Col xs={24}>
                            <ScrollAnimation threshold={0.1}>
                                <Row gutter={[16, 16]}>
                                    <Col flex={'auto'}>
                                        <BenefitItem
                                            icon={ImageBenefit1}
                                            color={'#82c34d'}
                                            title={'Ajuda a reduzir sintomas da dependência química.'}/>
                                    </Col>

                                    <Col flex={'auto'}>
                                        <BenefitItem
                                            icon={ImageBenefit2}
                                            color={'#fcb92d'}
                                            title={'Melhora quadros de epilepsia.'}/>
                                    </Col>
                                    <Col flex={'auto'}>
                                        <BenefitItem
                                            icon={ImageBenefit3}
                                            color={'#0098db'}
                                            title={'Auxilia nas sequelas do câncer.'}/>
                                    </Col>
                                    <Col flex={'auto'}>
                                        <BenefitItem
                                            icon={ImageBenefit4}
                                            color={'#006bb3'}
                                            title={'Alivia a dor.'}/>
                                    </Col>
                                    <Col flex={'auto'}>
                                        <BenefitItem
                                            icon={ImageBenefit5}
                                            color={'#a9518b'}
                                            title={'"Controla" ansiedade e ataques de pânico.'}/>
                                    </Col>
                                    <Col flex={'auto'}>
                                        <BenefitItem
                                            icon={ImageBenefit6}
                                            color={'#f48735'}
                                            title={'Auxilia na neuromodulação e em doenças neurodegenerativas. '}/>
                                    </Col>
                                    <Col flex={'auto'}>
                                        <BenefitItem
                                            icon={ImageBenefit7}
                                            color={'#eb3237'}
                                            title={'Melhora quadros do espectro autista e patologias relacionadas ao neurodesenvolvimento.'}/>
                                    </Col>
                                </Row>
                            </ScrollAnimation>
                        </Col>

                    </Row>
                </ContentContainer>
            </Benefit>
            {recentNews.length > 0 && <Section>
                <ContentContainer>
                    <ScrollAnimation direction={'left'}>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} style={{marginBottom: 32}}>
                                <MainTitle>Noticias
                                    recentes </MainTitle>
                            </Col>
                            <Col xs={24}>
                                <Row gutter={[24, 24]} align={'center'}>
                                    {recentNews.map(({
                                                         title,
                                                         created_at,
                                                         preview,
                                                         image,
                                                         slug
                                                     }) => (
                                        <Col xs={24} sm={12} lg={8}>
                                            <CardNews
                                                title={title}
                                                created_at={created_at}
                                                resume={preview}
                                                slug={slug}
                                                image={image}/></Col>

                                    ))}
                                </Row>

                            </Col>
                        </Row>
                    </ScrollAnimation>
                </ContentContainer>
            </Section>}
            {/*<Benefit>*/}
            {/*    <ContentContainer>*/}
            {/*        <Row gutter={[24, 24]}>*/}
            {/*            <Col xs={24} style={{marginBottom: 32}}>*/}
            {/*                <MainTitle style={{margin: '0 auto'}}>Descubra*/}
            {/*                    mais sobre nós</MainTitle>*/}
            {/*            </Col>*/}
            {/*            /!*<Col xs={24} >*!/*/}
            {/*            /!*    <VideoYoutube*!/*/}
            {/*            /!*        styled={{height: 400}}*!/*/}
            {/*            /!*            src="https://www.youtube.com/embed/mXKEjTcrkP4"*!/*/}
            {/*            /!*            title="YouTube video player"*!/*/}
            {/*            /!*            frameBorder="0"*!/*/}
            {/*            /!*            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*!/*/}
            {/*            /!*            allowFullScreen></VideoYoutube>*!/*/}
            {/*            /!*</Col>*!/*/}
            {/*            /!*<Col xs={12}>*!/*/}
            {/*            /!*    <VideoYoutube*!/*/}
            {/*            /!*            src="https://www.youtube.com/embed/mXKEjTcrkP4"*!/*/}
            {/*            /!*            title="YouTube video player"*!/*/}
            {/*            /!*            frameBorder="0"*!/*/}
            {/*            /!*            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*!/*/}
            {/*            /!*            allowFullScreen></VideoYoutube>*!/*/}
            {/*            /!*</Col>*!/*/}
            {/*            /!*<Col xs={12}>*!/*/}
            {/*            /!*    <VideoYoutube*!/*/}
            {/*            /!*            src="https://www.youtube.com/embed/mXKEjTcrkP4"*!/*/}
            {/*            /!*            title="YouTube video player"*!/*/}
            {/*            /!*            frameBorder="0"*!/*/}
            {/*            /!*            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*!/*/}
            {/*            /!*            allowFullScreen></VideoYoutube>*!/*/}
            {/*            /!*</Col>*!/*/}
            {/*        </Row>*/}
            {/*    </ContentContainer>*/}
            {/*</Benefit>*/}

            {settings.map_url && <Section style={{background: GREE_3}}>
                <ContentContainer>
                    <ScrollAnimation threshold={0.2} direction={'right'}>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} style={{marginBottom: 32}}>
                                <MainTitle color={'white'}>Nossa
                                    localização</MainTitle>
                            </Col>
                            <Col xs={24}>
                                <MapContainer>
                                    <GoogleMap
                                        src={settings.map_url}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="Localização CEBRAPCAM"
                                    />
                                </MapContainer>
                            </Col>
                        </Row>
                    </ScrollAnimation>
                </ContentContainer>
            </Section>}

        </>
    )
}


